/* Brand-neutral blog header — event-delegated.

   All click/input/keydown handlers attach ONCE on the document and look
   up state via DOM at the moment of the event. This means:
     - No per-element listeners that go stale on customizer hot-swap
     - New buttons rendered after a settings change work immediately
     - No instances WeakMap, no teardown/init dance, no shopify:section:load
       reliance for handler binding.
   Per-section state (stackIndex, searchTimer) lives in a WeakMap keyed
   by the section wrapper. On hot-swap, the wrapper is the same object,
   so state survives; if Shopify replaces the wrapper, the WeakMap entry
   is GC-ed naturally and a fresh state is created on next access. */

(function () {
  'use strict';

  var stateMap = new WeakMap();

  function getState(sectionEl) {
    var s = stateMap.get(sectionEl);
    if (!s) {
      s = { menuOpen: false, hidden: false, scrolled: false, stackIndex: 0, searchTimer: null };
      stateMap.set(sectionEl, s);
    }
    return s;
  }

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return root.querySelectorAll(sel); }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function lockBody() {
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    document.body.style.overflow = 'hidden';
  }
  function unlockBody() {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  function getSection(el) {
    return el && el.closest ? el.closest('.blog-header') : null;
  }

  function closeAll(sectionEl) {
    var state = getState(sectionEl);
    state.menuOpen = false;
    var card = $(sectionEl, '[data-blog-header-card]');
    var hamburger = $(sectionEl, '[data-blog-header-hamburger]');
    var searchBtn = $(sectionEl, '[data-blog-header-search-btn]');
    var searchDisplay = $(sectionEl, '[data-blog-header-search-display]');
    var searchInput = $(sectionEl, '[data-blog-header-search-input]');
    var searchResults = $(sectionEl, '[data-blog-header-search-results]');
    var searchLayer = $(sectionEl, '[data-blog-header-search-layer]');
    if (card) card.classList.remove('blog-header__card--open', 'blog-header__card--menu', 'blog-header__card--search');
    sectionEl.classList.remove('blog-header--search-open');
    if (hamburger) {
      hamburger.classList.remove('blog-header__hamburger--open');
      hamburger.setAttribute('aria-expanded', 'false');
    }
    if (searchBtn) searchBtn.classList.remove('blog-header__btn--close');
    unlockBody();
    if (searchDisplay) {
      searchDisplay.textContent = '';
      searchDisplay.classList.remove('blog-header__search-display--has-results');
    }
    if (searchInput) searchInput.value = '';
    if (searchResults) searchResults.innerHTML = '';
    if (searchLayer) searchLayer.classList.remove('blog-header__search-layer--has-results');
  }

  function openMenu(sectionEl) {
    closeAll(sectionEl);
    var state = getState(sectionEl);
    state.menuOpen = true;
    sectionEl.classList.remove('blog-header--hidden');
    lockBody();
    var card = $(sectionEl, '[data-blog-header-card]');
    var hamburger = $(sectionEl, '[data-blog-header-hamburger]');
    if (card) card.classList.add('blog-header__card--open', 'blog-header__card--menu');
    if (hamburger) {
      hamburger.classList.add('blog-header__hamburger--open');
      hamburger.setAttribute('aria-expanded', 'true');
    }
  }

  function openSearch(sectionEl) {
    var state = getState(sectionEl);
    state.menuOpen = true;
    var card = $(sectionEl, '[data-blog-header-card]');
    var hamburger = $(sectionEl, '[data-blog-header-hamburger]');
    var searchBtn = $(sectionEl, '[data-blog-header-search-btn]');
    var searchDisplay = $(sectionEl, '[data-blog-header-search-display]');
    if (hamburger) hamburger.classList.remove('blog-header__hamburger--open');
    sectionEl.classList.remove('blog-header--hidden');
    lockBody();
    if (card) {
      card.classList.remove('blog-header__card--menu');
      card.classList.add('blog-header__card--open', 'blog-header__card--search');
    }
    sectionEl.classList.add('blog-header--search-open');
    if (searchBtn) searchBtn.classList.add('blog-header__btn--close');
    if (searchDisplay) setTimeout(function () { searchDisplay.focus(); }, 400);
  }

  /* ---- Stack carousel update ---- */
  function updateStack(sectionEl) {
    var state = getState(sectionEl);
    var cards = $$(sectionEl, '.blog-header__menu-stack-card');
    if (!cards.length) return;
    cards.forEach(function (slide, i) {
      slide.classList.remove(
        'blog-header__menu-stack-card--active',
        'blog-header__menu-stack-card--next',
        'blog-header__menu-stack-card--behind'
      );
      if (i === state.stackIndex) slide.classList.add('blog-header__menu-stack-card--active');
      else if (i === (state.stackIndex + 1) % cards.length) slide.classList.add('blog-header__menu-stack-card--next');
      else if (i === (state.stackIndex + 2) % cards.length) slide.classList.add('blog-header__menu-stack-card--behind');
    });
  }

  /* ---- Predictive search ---- */
  function renderResults(sectionEl, data) {
    var searchResults = $(sectionEl, '[data-blog-header-search-results]');
    var searchDisplay = $(sectionEl, '[data-blog-header-search-display]');
    var searchLayer = $(sectionEl, '[data-blog-header-search-layer]');
    if (!searchResults) return;
    var resources = data && data.resources && data.resources.results;
    if (!resources) {
      searchResults.innerHTML = '';
      if (searchDisplay) searchDisplay.classList.remove('blog-header__search-display--has-results');
      if (searchLayer) searchLayer.classList.remove('blog-header__search-layer--has-results');
      return;
    }
    var q = searchDisplay ? (searchDisplay.textContent || '').trim().toLowerCase() : '';
    var items = [];
    if (resources.articles) {
      resources.articles.forEach(function (a) {
        if (a.title.toLowerCase().indexOf(q) !== -1) {
          items.push({
            type: 'article',
            title: a.title,
            url: a.url,
            image: a.image || (a.featured_image && a.featured_image.url) || ''
          });
        }
      });
    }
    if (items.length === 0) {
      searchResults.innerHTML = '<p class="blog-header__search-no-results">No results found</p>';
      if (searchDisplay) searchDisplay.classList.remove('blog-header__search-display--has-results');
      if (searchLayer) searchLayer.classList.remove('blog-header__search-layer--has-results');
      return;
    }
    var html = '';
    items.forEach(function (item) {
      html += '<a href="' + item.url + '" class="blog-header__search-result">';
      html += '<div class="blog-header__search-result-img">';
      if (item.image) html += '<img src="' + item.image + '" alt="" loading="lazy">';
      html += '</div>';
      html += '<div class="blog-header__search-result-title">' + escapeHtml(item.title) + '</div>';
      html += '<span class="blog-header__search-result-type">' + item.type.charAt(0).toUpperCase() + item.type.slice(1) + '</span>';
      html += '</a>';
    });
    searchResults.innerHTML = html;
    if (searchDisplay) searchDisplay.classList.add('blog-header__search-display--has-results');
    if (searchLayer) searchLayer.classList.add('blog-header__search-layer--has-results');
  }

  /* ---- Click delegation ---- */
  document.addEventListener('click', function (e) {
    var sectionEl;

    var searchBtn = e.target.closest('[data-blog-header-search-btn]');
    if (searchBtn) {
      e.preventDefault();
      e.stopPropagation();
      sectionEl = getSection(searchBtn);
      var card = sectionEl ? $(sectionEl, '[data-blog-header-card]') : null;
      if (sectionEl && card && card.classList.contains('blog-header__card--search')) closeAll(sectionEl);
      else if (sectionEl) openSearch(sectionEl);
      return;
    }

    var hamburger = e.target.closest('[data-blog-header-hamburger]');
    if (hamburger) {
      sectionEl = getSection(hamburger);
      var c2 = sectionEl ? $(sectionEl, '[data-blog-header-card]') : null;
      if (sectionEl && c2 && c2.classList.contains('blog-header__card--menu')) closeAll(sectionEl);
      else if (sectionEl) openMenu(sectionEl);
      return;
    }

    var stackPrev = e.target.closest('[data-blog-header-stack-prev]');
    if (stackPrev) {
      e.stopPropagation();
      sectionEl = getSection(stackPrev);
      if (sectionEl) {
        var state = getState(sectionEl);
        var cards = $$(sectionEl, '.blog-header__menu-stack-card');
        if (cards.length) {
          state.stackIndex = (state.stackIndex - 1 + cards.length) % cards.length;
          updateStack(sectionEl);
        }
      }
      return;
    }

    var stackNext = e.target.closest('[data-blog-header-stack-next]');
    if (stackNext) {
      e.stopPropagation();
      sectionEl = getSection(stackNext);
      if (sectionEl) {
        var s2 = getState(sectionEl);
        var c3 = $$(sectionEl, '.blog-header__menu-stack-card');
        if (c3.length) {
          s2.stackIndex = (s2.stackIndex + 1) % c3.length;
          updateStack(sectionEl);
        }
      }
      return;
    }

    var menuLink = e.target.closest('.blog-header__menu-link');
    if (menuLink) {
      sectionEl = getSection(menuLink);
      if (sectionEl) closeAll(sectionEl);
      return;
    }
  });

  /* ---- Search input delegation ---- */
  document.addEventListener('input', function (e) {
    var display = e.target.closest('[data-blog-header-search-display]');
    if (!display) return;
    var sectionEl = getSection(display);
    if (!sectionEl) return;
    var state = getState(sectionEl);
    var searchInput = $(sectionEl, '[data-blog-header-search-input]');
    var searchResults = $(sectionEl, '[data-blog-header-search-results]');
    var searchLayer = $(sectionEl, '[data-blog-header-search-layer]');
    var q = (display.textContent || '').trim();
    if (searchInput) searchInput.value = q;
    clearTimeout(state.searchTimer);
    if (q.length < 2) {
      if (searchResults) searchResults.innerHTML = '';
      display.classList.remove('blog-header__search-display--has-results');
      if (searchLayer) searchLayer.classList.remove('blog-header__search-layer--has-results');
      return;
    }
    state.searchTimer = setTimeout(function () {
      var inner = $(sectionEl, '[data-blog-header]');
      var endpoint = (inner && inner.dataset.searchEndpoint) || '/search/suggest.json';
      var url = endpoint + '?q=' + encodeURIComponent(q) +
                '&resources[type]=article&resources[limit]=8' +
                '&resources[options][fields]=title,body,tag';
      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        renderResults(sectionEl, data);
      }).catch(function () {});
    }, 300);
  });

  /* ---- ESC to close ---- */
  document.addEventListener('keydown', function (e) {
    if (e.keyCode !== 27) return;
    var open = document.querySelector('.blog-header .blog-header__card--open');
    if (!open) return;
    var sectionEl = getSection(open);
    if (sectionEl) closeAll(sectionEl);
  });

  /* ---- Touch swipe on stack ---- */
  var touchStartX = 0, touchStartY = 0, touchSection = null;
  document.addEventListener('touchstart', function (e) {
    var stack = e.target.closest('[data-blog-header-stack]');
    if (!stack) { touchSection = null; return; }
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchSection = getSection(stack);
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!touchSection) return;
    var dx = e.changedTouches[0].clientX - touchStartX;
    var dy = e.changedTouches[0].clientY - touchStartY;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
      var s = getState(touchSection);
      var cards = $$(touchSection, '.blog-header__menu-stack-card');
      if (cards.length) {
        if (dx < 0) s.stackIndex = (s.stackIndex + 1) % cards.length;
        else s.stackIndex = (s.stackIndex - 1 + cards.length) % cards.length;
        updateStack(touchSection);
      }
    }
    touchSection = null;
  }, { passive: true });

  /* ---- Scroll: hide-on-down, show-on-up; activate scrolled past 60 ---- */
  var scrollTicking = false;
  var lastScrollY = window.scrollY;
  function onScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY;
      var delta = y - lastScrollY;
      var sections = document.querySelectorAll('.blog-header');
      sections.forEach(function (sectionEl) {
        var state = getState(sectionEl);
        if (y > 60 && !state.scrolled) {
          sectionEl.classList.add('blog-header--scrolled');
          state.scrolled = true;
        } else if (y <= 60 && state.scrolled) {
          sectionEl.classList.remove('blog-header--scrolled');
          state.scrolled = false;
        }
        if (delta > 10 && y > 100 && !state.hidden && !state.menuOpen) {
          sectionEl.classList.add('blog-header--hidden');
          state.hidden = true;
        } else if (delta < -10 && state.hidden) {
          sectionEl.classList.remove('blog-header--hidden');
          state.hidden = false;
        }
      });
      lastScrollY = y;
      scrollTicking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---- Initial stack render on load ---- */
  function initialStackRender() {
    document.querySelectorAll('.blog-header').forEach(updateStack);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialStackRender);
  } else {
    initialStackRender();
  }

  /* Re-render stack after customizer hot-swap. Stack starts at index 0 in
     fresh DOM so this is a defensive sync. */
  document.addEventListener('shopify:section:load', function (e) {
    var sectionEl = (e.target && e.target.classList && e.target.classList.contains('blog-header'))
      ? e.target
      : (e.target && e.target.querySelector ? e.target.querySelector('.blog-header') : null);
    if (sectionEl) updateStack(sectionEl);
  });
})();
